export default __webpack_public_path__ + "static/media/a037-7.68be5844.svg";